import React from 'react';
import { CheckBox } from '../Forms/Forms'
import CONSTANTS from '../../Constants'

const DealersFilter = ({ onFilterClick }) => {


    return (

        <div className="filter-block">
            <CheckBox
                id="filterLcvPc"
                onClick={(e) => { onFilterClick(e) }}
                label={CONSTANTS.LABELS.dealer_quote_filter}
            />
        </div>

    )
}
export default DealersFilter;